var map = {
	"./access-code/access-code.module": [
		"./src/app/access-code/access-code.module.ts",
		"default~access-code-access-code-module~admin-admin-module~dashboard-dashboard-module~export-export-m~62c580f9",
		"default~access-code-access-code-module~patient-patient-module",
		"common",
		"access-code-access-code-module"
	],
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"default~access-code-access-code-module~admin-admin-module~dashboard-dashboard-module~export-export-m~62c580f9",
		"default~admin-admin-module~export-export-module~stats-stats-module",
		"common",
		"admin-admin-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~access-code-access-code-module~admin-admin-module~dashboard-dashboard-module~export-export-m~62c580f9",
		"default~dashboard-dashboard-module~information-information-module~patient-patient-module~stats-stats~a32a411a",
		"default~dashboard-dashboard-module~patient-patient-module",
		"common"
	],
	"./export/export.module": [
		"./src/app/export/export.module.ts",
		"default~access-code-access-code-module~admin-admin-module~dashboard-dashboard-module~export-export-m~62c580f9",
		"default~admin-admin-module~export-export-module~stats-stats-module",
		"common",
		"export-export-module"
	],
	"./information/information.module": [
		"./src/app/information/information.module.ts",
		"default~dashboard-dashboard-module~information-information-module~patient-patient-module~stats-stats~a32a411a",
		"common",
		"information-information-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"default~access-code-access-code-module~admin-admin-module~dashboard-dashboard-module~export-export-m~62c580f9",
		"common",
		"login-login-module"
	],
	"./news-dashboard/news-dashboard.module": [
		"./src/app/news-dashboard/news-dashboard.module.ts",
		"news-dashboard-news-dashboard-module"
	],
	"./patient/patient.module": [
		"./src/app/patient/patient.module.ts",
		"default~access-code-access-code-module~admin-admin-module~dashboard-dashboard-module~export-export-m~62c580f9",
		"default~dashboard-dashboard-module~information-information-module~patient-patient-module~stats-stats~a32a411a",
		"default~dashboard-dashboard-module~patient-patient-module",
		"default~patient-patient-module~stats-stats-module",
		"default~access-code-access-code-module~patient-patient-module",
		"common",
		"patient-patient-module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"common",
		"settings-settings-module"
	],
	"./stats/stats.module": [
		"./src/app/stats/stats.module.ts",
		"default~access-code-access-code-module~admin-admin-module~dashboard-dashboard-module~export-export-m~62c580f9",
		"default~dashboard-dashboard-module~information-information-module~patient-patient-module~stats-stats~a32a411a",
		"default~admin-admin-module~export-export-module~stats-stats-module",
		"default~patient-patient-module~stats-stats-module",
		"common",
		"stats-stats-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;